import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { Calendar, Clock, MapPin } from 'lucide-react';

// Format date as "Sun, Mar 15"
const formatDateShort = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString + 'T00:00:00');
  const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const day = date.getDate();
  return `${weekday}, ${month} ${day}`;
};

export const UpcomingTrainingWidget = ({ upcomingTrainings, user }) => (
  <div className="h-full" data-testid="upcoming-training">
    <div className="flex flex-row items-center justify-between pb-4">
      <h3 className="text-xl font-semibold font-title">Training</h3>
      <Link to="/training">
        <Button variant="ghost" size="sm" style={{ color: user?.menu_color || '#059669' }} className="hover:opacity-80">
          View All
        </Button>
      </Link>
    </div>
    <div>
      {upcomingTrainings.length > 0 ? (
        <div className="flex flex-col gap-4">
          {upcomingTrainings.map((training) => (
            <div key={training.id} className="flex items-center justify-between p-3 bg-white rounded-xl" style={{ border: '1px solid #e5e2dc' }}>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center bg-teal-100">
                  <Calendar className="w-5 h-5 text-teal-600" strokeWidth={1.5} />
                </div>
                <div>
                  <p className="font-medium text-gray-900">{formatDateShort(training.date)}</p>
                  <div className="flex items-center gap-2 text-sm text-gray-500">
                    <Clock className="w-3.5 h-3.5" strokeWidth={1.5} />
                    <span>{training.start_time}{training.end_time ? ` - ${training.end_time}` : ''}</span>
                  </div>
                </div>
              </div>
              {training.location && (
                <div className="flex items-center gap-1.5 text-sm text-gray-500">
                  <MapPin className="w-3.5 h-3.5" strokeWidth={1.5} />
                  <span className="max-w-[120px] truncate">{training.location}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-400">
          <Calendar className="w-10 h-10 mx-auto mb-2 opacity-50" strokeWidth={1.5} />
          <p>No upcoming sessions</p>
        </div>
      )}
    </div>
  </div>
);

export default UpcomingTrainingWidget;
